import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import Instagram from "../../assets/instagram";
import Facebook from "../../assets/facebook";
import { isMobile, isIPad13, isTablet } from "react-device-detect";

const isNotMobile = !isMobile || isIPad13 || isTablet;
const HeroSliderEightSingle = ({ data, sliderClass }) => {
  return (
    <div
    className={`single-slider slider-height-1 d-flex align-items-center slider-height-res hm-13-slider h-full ${
      sliderClass ? sliderClass : ""
    }`}
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL + data.image})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom",
    }}
  >
      
          <div style={{ width: "100%",     padding: '5rem' }}>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ maxWidth: "100%" }}
              >
                <div className="slider-content-13 slider-animated-1">
                <h1 dangerouslySetInnerHTML={{ __html: data.title }} />
                  <h2 dangerouslySetInnerHTML={{ __html: data.subtitle }} />
                </div>
              </div>
          </div>
      </div>
  );
};

HeroSliderEightSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string,
};

export default HeroSliderEightSingle;
